import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * MICD (Fec menos Fec Anterior Suavizado, FML.MICD) — painel próprio,
 * 2 linhas: DIF e MICD. yAccessor(d) retorna { dif, micd }.
 */
class MICDSeries extends Component {
  constructor(props) {
    super(props);
    this.difAccessor = this.difAccessor.bind(this);
    this.micdAccessor = this.micdAccessor.bind(this);
  }
  difAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.dif;
  }
  micdAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.micd;
  }
  render() {
    const { strokeDif, strokeMicd, className } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.difAccessor}
          stroke={strokeDif}
          fill="none"
        />
        <LineSeries
          yAccessor={this.micdAccessor}
          stroke={strokeMicd}
          fill="none"
        />
      </g>
    );
  }
}

MICDSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeDif: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeMicd: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

MICDSeries.defaultProps = {
  strokeDif: { color: "#FFFF00" },
  strokeMicd: { color: "#FF0000" },
  className: "react-stockcharts-micd-series",
};

export default MICDSeries;
